import _ from 'lodash';

import { BETSLIP_TYPE_CHAIN, BETSLIP_TYPE_EXPRESS, BETSLIP_TYPE_SINGLE, BETSLIP_TYPE_SYSTEM, detectConflicts } from "../helpers/sport/betslip";
import Helpers from "../helpers/helperFunctions";
import Config from "../config/main";
import {
    BETSLIP_ADD, BETSLIP_REMOVE, CHANGE_HORSE_EVENT_TYPE, BETSLIP_CLEAR, BETSLIP_SET_TYPE, BETSLIP_SET_EACH_WAY_MODE, BETSLIP_TOGGLE_QUICKBET,
    BETSLIP_ACCEPT_CHANGES, BETSLIP_SET_STAKE, BETSLIP_SET_UNIT_STAKE, BETSLIP_SET_SYSTEM_OPT, BETSLIP_SET_ACCEPT_OPT,
    BETSLIP_SET_INCLUDE_IN_SYSTEM_CALC, BETSLIP_BET_ACCEPTED, BETSLIP_BET_FAILED, BETSLIP_BET_FAILED_RESET, BETSLIP_RESET_STATUS, SET_BET_EVENT_COUNTER_OFFER_ODD,
    BETSLIP_BET_PROCESSING, BETSLIP_QUICK_BET_NOTIFY, BETSLIP_QUICK_BET_NOTIFY_DISMISS, BETSLIP_TOGGLE_FREEBET,
    BETSLIP_TOGGLE_SUPERBET, BETSLIP_SET_FREE_BETS, BETSLIP_SELECT_FREE_BET, BETSLIP_UNSELECT_FREE_BET, BETSLIP_TOGGLE_FREEBET_LOADING_STATE, BETSLIP_TOGGLE_COUNTER_OFFER,
    BETSLIP_TOGGLE_BOOKINGBET, SET_UK_BETSLIP_OPTION_STAKE, TOGGLE_UK_BETSLIP_MULTIPLE_OPTIONS, UNSET_UK_BETSLIP_OPTION_STAKE, UPDATE_BETSLIP_EVENTS,
    UNSET_UK_BETSLIP_OPTION, BETSLIP_SET_ALL_EVENTS_STAKE, BETSLIP_COPY, LOGGED_OUT, BETSLIP_ADDS, CHANGE_TYPE_TO_FORECAST_OR_TRICAST, BETSLIP_REPEAT_BET, BETSLIP_CLEAR_LAST_BET, BETSLIP_SET_ACTIVE_EVENT, BETSLIP_SET_SYSTEM_ACTIVE_INPUT, BETSLIP_SET_OFFERED_PRICE
} from "../actions/actionTypes/";
import { BetPriceChangeEnum } from '../constants/enums/betPriceChange';

const multipleSelectionTypes = [BETSLIP_TYPE_EXPRESS, BETSLIP_TYPE_SYSTEM, BETSLIP_TYPE_CHAIN];

const filterNonNumeric = str => Number(str.toString().replace(/[^0-9.,]/, ""));

const BetslipReducer = (
    state = {
        lastBet: null,
        activeEventId: null,
        events: {},
        horseEvents: {},
        eventsLimitExceeded: false,
        bankerBetsCount: 0,
        type: 1, // if forecast 10 if tricast 11 maybe 3 to 10 is not used
        sysOptionValue: 2,
        stake: "",
        unitStake: "",
        eachWayMode: false,
        betterOddSelectionMode: false,
        freeBet: false,
        freeBetLoading: false,
        freeBetsList: [],
        selectedFreeBetId: null,
        selectedFreeBetAmount: null,
        bonusBet: false,
        betAccepted: null,
        betFailed: null,
        quickBet: false,
        superBet: false,
        bookingBet: false,
        quickBetNotifications: {},
        multipleOptions: {},
        acceptPriceChanges: Config.betting.acceptOddDefaultType,
        activeInput: null
    },
    action
) => {
    let ret = Helpers.cloneDeep(state);

    switch (action.type) {
        case BETSLIP_SET_ACTIVE_EVENT:
            ret.activeEventId = action.eventId
            return ret
        case BETSLIP_SET_SYSTEM_ACTIVE_INPUT:
            ret.activeInput = action.activeInput
            return ret
        case BETSLIP_SET_TYPE:
            ret.type = action.betSlipType;
            return ret;
        case BETSLIP_ADD:
            ret.events = Object.assign({}, ret.events); //clone
            ret.events[action.payload.eventId] = { ...action.payload, __originalAddedOrder: Object.values(ret.events).length + 1 };
            ret.activeEventId = action.payload.eventId
            if (Object.keys(ret.events).length > 1 && !multipleSelectionTypes.includes(ret.type))
                if (ret.type < 40)
                    ret.type = BETSLIP_TYPE_EXPRESS

            detectConflicts(ret.events);
            return ret;
        case BETSLIP_ADDS:
            ret.events = Object.assign({}, ret.events); //clone
            action.payload.map(event => {
                ret.events[event.id] = event;
            });
            return ret;
        case BETSLIP_COPY:
            ret.events = Object.assign({}, ret.events); //clone
            action.payload.events.event.map(event => {
                ret.events[event.selection_id] = event;
            });
            detectConflicts(ret.events);
            return ret;
        case CHANGE_HORSE_EVENT_TYPE:
            ret.horseEvents = { ...ret.horseEvents, [action.payload.id]: { eventId: action.payload.id, type: action.payload.type, gameId: action.payload.gameId } };
            return ret;
        case CHANGE_TYPE_TO_FORECAST_OR_TRICAST:
            ret.type = action.payload.type;
            return ret;
        case BETSLIP_REMOVE:
            if (ret.events[action.payload.eventId]) {
                ret.events = Object.assign({}, ret.events); //clone
                delete ret.events[action.payload.eventId];
            }
            if (action.payload.withHorse && ret.horseEvents[action.payload.eventId]) {
                ret.horseEvents = Object.assign({}, ret.horseEvents); //clone
                if (Object.keys(ret.horseEvents).length === 1) ret.type = BETSLIP_TYPE_SINGLE
                delete ret.horseEvents[action.payload.eventId];
            }
            detectConflicts(ret.events);
            return ret;
        case BETSLIP_BET_PROCESSING:
            ret.events = Object.assign({}, ret.events); //clone
            action.eventIds.map(id => { ret.events[id] && (ret.events[id].processing = action.status); });
            return ret;
        case BETSLIP_REPEAT_BET:
            if (ret.lastBet) return { ...ret, ...ret.lastBet };
            return ret;
        case BETSLIP_CLEAR_LAST_BET:
            delete ret.lastBet;
            return ret;
        case BETSLIP_CLEAR:
            if (action.betPlaced && !_.isEmpty(ret.events)) {
                ret.lastBet = {
                    events: { ...ret.events },
                    type: ret.type,
                    stake: ret.stake,
                    sysOptionValue: ret.sysOptionValue,
                };
            }

            ret.freeBet = false;
            ret.events = {};
            ret.horseEvents = {};
            ret.stake = 0;
            ret.type = BETSLIP_TYPE_SINGLE

            if (action.processedOnly) {
                Object.keys(ret.events).map(id => {
                    if (ret.events[id].processing) {
                        ret.events[id] = state.events[id];
                    }
                });
            }
            return ret;
        case BETSLIP_ACCEPT_CHANGES: {
            ret.events = Object.assign({}, ret.events); //clone
            let toRemove = [];
            Object.keys(ret.events).map(id => {
                ret.events[id].initialPrice = ret.events[id].price;
                ret.events[id].initialBase = ret.events[id].base;
                if (!ret.events[id].available) {
                    toRemove.push(id);
                }
            });
            // toRemove.map(id => { delete ret.events[id]; });
            return ret;
        }
        case UPDATE_BETSLIP_EVENTS: {
            let update = {};
            Object.keys(action.payload).map((eventId) => {
                if (ret.events.hasOwnProperty(eventId)) {
                    update[eventId] = {
                        ...ret.events[eventId],
                        ...action.payload[eventId]
                    };
                }
            });

            return {
                ...ret,
                events: {
                    ...ret.events,
                    ...update
                }
            };
        }
        case SET_BET_EVENT_COUNTER_OFFER_ODD:
            return {
                ...state,
                events: {
                    ...state.events,
                    [action.key]: {
                        ...state.events[action.key],
                        counterOfferOdd: action.payload
                    }
                }
            };
        case BETSLIP_TOGGLE_QUICKBET:
            ret.quickBet = action.enabled;
            return ret;
        case BETSLIP_TOGGLE_SUPERBET:
            ret.superBet = action.enabled;
            return ret;
        case BETSLIP_TOGGLE_COUNTER_OFFER:
            ret.counterOffer = action.enabled;
            return ret;
        case BETSLIP_TOGGLE_BOOKINGBET:
            ret.bookingBet = action.enabled;
            return ret;
        case BETSLIP_TOGGLE_FREEBET:
            ret.freeBet = action.enabled;
            return ret;
        case LOGGED_OUT:
            ret.freeBet = false;
            return ret;
        case BETSLIP_TOGGLE_FREEBET_LOADING_STATE:
            ret.freeBetLoading = action.payload;
            return ret;
        case BETSLIP_SET_EACH_WAY_MODE:
            ret.eachWayMode = action.value;
            return ret;
        case BETSLIP_SET_ACCEPT_OPT:
            ret.acceptPriceChanges = action.value;
            return ret;
        case BETSLIP_SET_SYSTEM_OPT:
            ret.sysOptionValue = action.value;
            return ret;
        case BETSLIP_SET_STAKE:
            if (action.eventId) {
                ret.events[action.eventId].singleStake = filterNonNumeric(action.value);
            } else {
                ret.stake = filterNonNumeric(action.value);
            }
            return ret;
        case BETSLIP_SET_OFFERED_PRICE:
            if (action.eventId) {
                ret.events[action.eventId].offeredPrice = filterNonNumeric(action.value);
            }
            return ret;
        case BETSLIP_SET_ALL_EVENTS_STAKE: {
            ret.events = Object.assign({}, ret.events);
            Object.keys(ret.events).map(id => {
                ret.events[id].singleStake = filterNonNumeric(action.value);
            });
            return ret;
        }
        case BETSLIP_SET_INCLUDE_IN_SYSTEM_CALC:
            ret.events[action.eventId].incInSysCalc = action.value;
            return ret;
        case BETSLIP_SET_UNIT_STAKE:
            if (action.eventId) {
                ret.events[action.eventId].singleUnitStake = filterNonNumeric(action.value);
            } else {
                ret.unitStake = filterNonNumeric(action.value);
            }
            return ret;
        case BETSLIP_BET_ACCEPTED:
            ret.events = Object.assign({}, ret.events);
            ret.type = BETSLIP_TYPE_SINGLE
            action.payload.details.events.map(event => {
                ret.events[event.selection_id] && (ret.events[event.selection_id].processing = false);
            });
            ret.betAccepted = action.payload.isConfirmed && action.payload;
            return ret;
        case BETSLIP_BET_FAILED:
            ret.betFailed = action.payload;
            return ret;
        case BETSLIP_QUICK_BET_NOTIFY_DISMISS:
            ret.quickBetNotifications = Object.assign({}, ret.quickBetNotifications);
            delete ret.quickBetNotifications[action.id];
            return ret;
        case BETSLIP_QUICK_BET_NOTIFY:
            ret.quickBetNotifications = Object.assign({}, ret.quickBetNotifications);
            ret.quickBetNotifications[action.id] = { type: action.resultType, msg: action.payload };
            return ret;
        case BETSLIP_SET_FREE_BETS:
            ret.freeBetsList = action.payload;
            return ret;
        case BETSLIP_SELECT_FREE_BET:
            ret.selectedFreeBetId = action.id;
            ret.selectedFreeBetAmount = action.amount;
            return ret;
        case BETSLIP_UNSELECT_FREE_BET:
            ret.selectedFreeBetId = null;
            ret.selectedFreeBetAmount = null;
            return ret;
        case BETSLIP_RESET_STATUS:
            ret.betAccepted = null;
            ret.betFailed = null;
            ret.quickBetNotifications = {};
            return ret;
        case TOGGLE_UK_BETSLIP_MULTIPLE_OPTIONS:
            return {
                ...state,
                multipleOptions: {
                    ...state.multipleOptions,
                    enabled: !state.multipleOptions.enabled
                }
            };
        case SET_UK_BETSLIP_OPTION_STAKE:
            return {
                ...state,
                multipleOptions: {
                    ...state.multipleOptions,
                    [action.meta]: {
                        ...state.multipleOptions[action.meta],
                        ...action.payload
                    }
                }
            };
        case UNSET_UK_BETSLIP_OPTION: {
            let ret = {
                ...state,
                multipleOptions: {
                    ...state.multipleOptions
                }
            };
            delete ret.multipleOptions[action.payload];
            return ret;
        }
        case UNSET_UK_BETSLIP_OPTION_STAKE: {
            let ret = {
                ...state,
                multipleOptions: {
                    ...state.multipleOptions,
                    [action.payload]: {
                        ...state.multipleOptions[action.payload],
                        value: ""
                    }
                }
            };
            return ret;
        }
        default:
            return state;
    }
};

export default BetslipReducer;
